<div
  class="w-full flex gap-2 flex-wrap"
  [class.flex-col]="valueView === 'list' || inputView !== 'common'"
  >
  @if (value.length > 0) {
    @switch (valueView) {
      @case ('list') {
        <ng-container *ngTemplateOutlet="valueListView"></ng-container>
      }
      @default {
        <ng-container *ngTemplateOutlet="valueGridView"></ng-container>
      }
    }
  }

  @switch (inputView) {
    @case ('dragAndDrop') {
      <ng-container *ngTemplateOutlet="dragAndDrop"></ng-container>
    }
    @default {
      <ng-container *ngTemplateOutlet="common"></ng-container>
    }
  }
</div>

<ng-template #valueGridView>
  @for (file of value; track file; let i = $index) {
    <div>
      <div class="grid-value-image h-full">
        <div
          class="grid-value-view items-center justify-between"
          (click)="onShowGallery(i)"
        [ngStyle]="{
          backgroundImage:
            'url(' + ((file | localImage | async) || 'none') + ')'
        }"
          >
          @if (
            progress | single: getProgress:file; as fileProgress) {
            @if (
              fileProgress.state === 'pending' ||
              fileProgress.state === 'processing'
              ) {
              <i
                class="fa-regular fa-spinner fa-spin icon"
              ></i>
            }
            @if (fileProgress.state === 'succeeded') {
              <i
                class="fa-regular fa-check icon succeeded"
              ></i>
            }
          } @else {
            @if (!readonly && !disabled) {
              <i
                class="fa-regular fa-xmark icon delete px-2"
                (click)="onDelete($any(file))"
              ></i>
            }
          }
          <div class="mt-5">
            <ng-container
              *ngTemplateOutlet="fileIcon; context: { $implicit: file.type }"
            ></ng-container>
          </div>
          <span
            title="{{ file.name }}"
            class="text-xs whitespace-nowrap text-center px-2 mb-3 truncate"
            >
            {{ file.name }}
          </span>
          @if (progress | single: getProgress:file; as fileProgress) {
            <div
              class="progress-bar"
            [ngStyle]="{
              width:
                ([
                  (fileProgress.uploaded * 100) /
                    (fileProgress.total || file.size),
                  100
                ]
                  | min
                  | number: '1.0-0') + '%'
            }"
            ></div>
          }
        </div>
      </div>
    </div>
  }
</ng-template>
<ng-template #valueListView>
  <div>
    @for (file of value; track file; let i = $index) {
      <div class="soft-file-list">
        <div class="soft-file-list-item">
          <div class="v-stack pl-2 pt-2 pb-2 w-full">
            <span class="soft-file-list-item-description truncate max-w-[50vw]">{{
              file.name
            }}</span>
            <span class="soft-file-list-item-filesize">
              @if (
                progress | single: getProgress:file; as fileProgress) {
                {{ fileProgress.uploaded | filesize }} /
                {{ fileProgress.total | filesize }}
              } @else {
                {{ file.size | filesize }}
              }
            </span>
          </div>
          @if (
            progress | single: getProgress:file; as fileProgress) {
            @if (
              fileProgress.state === 'pending' ||
              fileProgress.state === 'processing'
              ) {
              <i
                class="fa-regular fa-spinner fa-spin soft-file-list-item-processing"
              ></i>
            }
            @if (fileProgress.state === 'succeeded') {
              <i
                class="fa-regular fa-check soft-file-list-item-succeeded"
              ></i>
            }
            <div
              class="progress"
            [ngClass]="
              'progress-' +
              ([
                (fileProgress.uploaded * 100) /
                  (fileProgress.total || file.size),
                100
              ]
                | min
                | number: '1.0-0')
            "
            ></div>
          } @else {
            <span class="flex flex-nowrap">
              @if (file.name | isImage) {
                <i
                  class="fa-regular fa-eye p-3 galleryButton"
                  (click)="onShowGallery(i)"
                ></i>
              }
              @if (!readonly && !disabled) {
                <i
                  class="fa-regular fa-xmark color-danger soft-file-list-item-delete"
                  (click)="onDelete(i)"
                ></i>
              }
            </span>
          }
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #dragAndDrop>
  <div [class.readonly]="disabled || readonly">
    @if (
      (selectionMode === 'multi' && value.length >= 0) ||
      (selectionMode === 'single' && value.length === 0)
      ) {
      <div
        class="soft-drag-drop-container"
      [ngClass]="{
        'p-16': this.userAgentService.isDesktop(),
        'p-4': !this.userAgentService.isDesktop()
      }"
        [class.readonly]="disabled || readonly"
        softDragDrop
        (fileDropped)="onSelectFile($event)"
        (click)="onChooseFile()"
        >
        @if (value.length > 0) {
          <span
            class="soft-chip pos-abs selected-files-length"
            >
            {{
            (('file' | in: _sources)
            ? '#UI_CORE.COMPONENTS.FILE_INPUT.FILE_COUNT'
            : '#UI_CORE.COMPONENTS.FILE_INPUT.IMAGE_COUNT') +
            (value.length > 1 ? '_PL' : '')
            | translate
            | interpolate: { count: value.length }
            }}
          </span>
        }
        @if ('file' | in: _sources) {
          <i
            class="fa-regular fa-cloud-arrow-up fa-3x text-primary-400"
          ></i>
        }
        @if (('file' | in: _sources) === false) {
          <i
            class="fa-regular fa-camera fa-3x text-primary-400"
          ></i>
        }
        <span class="soft-drag-drop-description mb-4">
          {{
          '#UI_CORE.COMPONENTS.FILE_INPUT.DRAG_AND_DROP_DESC' +
          (selectionMode === 'multi' ? '_PL' : '') | translate
          }}
        </span>
        <a class="text-sm font-bold text-primary cursor-pointer hover:underline">
          {{
          (('file' | in: _sources)
          ? '#UI_CORE.COMPONENTS.FILE_INPUT.CHOOSE_FILE'
          : '#UI_CORE.COMPONENTS.FILE_INPUT.CHOOSE_IMAGE'
          ) | translate
          }}
        </a>
      </div>
    }
  </div>
</ng-template>

<ng-template #common>
  @if (value.length === 0 || selectionMode === 'multi') {
    <div
      class="common-input-view py-3"
      [class.readonly]="disabled || readonly"
      (click)="onChooseFile()"
      >
      <div class="grid-value-view items-center justify-between">
        <i class="fa-regular fa-plus fa-3x text-primary-400 mt-2"></i>
        <span class="text-xs whitespace-nowrap text-center truncate">
          {{
          (('file' | in: _sources)
          ? '#UI_CORE.COMPONENTS.FILE_INPUT.ADD_FILE'
          : '#UI_CORE.COMPONENTS.FILE_INPUT.ADD_IMAGE'
          ) | translate
          }}
        </span>
      </div>
    </div>
  }
</ng-template>

<ng-template let-fileType #fileIcon>
  @switch (fileType) {
    @case ('image/png') {
      <i></i>
    }
    @case ('image/jpeg') {
      <i></i>
    }
    @case ('image/gif') {
      <i></i>
    }
    @case ('image/svg+xml') {
      <i></i>
    }
    @case ('application/pdf') {
      <i
        class="fa-regular fa-file-pdf fa-3x text-primary-400"
      ></i>
    }
    @case ('application/msword') {
      <i
        class="fa-regular fa-file-word fa-3x text-primary-400"
      ></i>
    }
    @case (
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ) {
      <i
        class="fa-regular fa-file-word fa-3x text-primary-400"
      ></i>
    }
    @case ('application/vnd.ms-excel') {
      <i
        class="fa-regular fa-file-xls fa-3x text-primary-400"
      ></i>
    }
    @case (
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
      <i
        class="fa-regular fa-file-xls fa-3x text-primary-400"
      ></i>
    }
    @case ('application/vnd.ms-outlook') {
      <i
        class="fa-regular fa-envelope fa-3x text-primary-400"
      ></i>
    }
    @case ('application/zip') {
      <i
        class="fa-regular fa-file-zip fa-3x text-primary-400"
      ></i>
    }
    @default {
      <i class="fa-regular fa-file fa-3x text-primary-400"></i>
    }
  }
</ng-template>
